export const recordsChanged = state => {
  return state['renewal']['records']['changed'];
};

export default recordsChanged;
